// Module
var code = "<router-link :class=\"`editLink t-editLink_${eventName}`\" :to=\"getLink(linkPath)\" @click.native=\"trackEvent(eventName)\">{{ t('summary_edit') }}</router-link> ";
// Exports
export default code;